/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ServiceJourney } from './ServiceJourney';
import {
    ServiceJourneyFromJSON,
    ServiceJourneyToJSON,
} from './ServiceJourney';
import type { LinkBox } from './LinkBox';
import {
    LinkBoxFromJSON,
    LinkBoxToJSON,
} from './LinkBox';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetToJSON,
} from './Asset';

/**
 * Home page response model
 * @export
 * @interface Home
 */
export interface Home {
    /**
     *
     * @type {string}
     * @memberof Home
     */
    headerTitle: string;
    /**
     *
     * @type {Asset}
     * @memberof Home
     */
    headerImage?: Asset | null;
    /**
     *
     * @type {Array<LinkBox>}
     * @memberof Home
     */
    linkBoxes: LinkBox[];
    /**
     *
     * @type {ServiceJourney}
     * @memberof Home
     */
    employeeJourney?: ServiceJourney | null;
}

/**
 * Check if a given object implements the Home interface.
 */
export function instanceOfHome(value: object): value is Home {
    if (!('headerTitle' in value) || value['headerTitle'] === undefined) return false;
    if (!('linkBoxes' in value) || value['linkBoxes'] === undefined) return false;
    return true;
}

export function HomeFromJSON(json: any): Home {
    return HomeFromJSONTyped(json, false);
}

export function HomeFromJSONTyped(json: any, _: boolean): Home {
    if (json == null) {
        return json;
    }
    return {

        'headerTitle': json['header_title'],
        'headerImage': json['header_image'] == null ? undefined : AssetFromJSON(json['header_image']),
        'linkBoxes': ((json['link_boxes'] as any[]).map(LinkBoxFromJSON)),
        'employeeJourney': json['employee_journey'] == null ? undefined : ServiceJourneyFromJSON(json['employee_journey']),
    };
}

export function HomeToJSON(json: any): Home {
    return HomeToJSONTyped(json, false);
}

export function HomeToJSONTyped(value?: Home | null, _: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'header_title': value['headerTitle'],
        'header_image': AssetToJSON(value['headerImage']),
        'link_boxes': ((value['linkBoxes'] as any[]).map(LinkBoxToJSON)),
        'employee_journey': ServiceJourneyToJSON(value['employeeJourney']),
    };
}
